// Shared pillar-card band colours (School + Portfolio). 80/60 bands; grey = not started / no score.
export function healthColorForScore(score, completion_pct) {
  if (score == null || completion_pct === 0) return { label: "Not started", bar: "bg-[#e5e7eb]", tone: "grey" };
  if (score >= 80) return { label: "Healthy", bar: "bg-[#16a34a]", tone: "green" };
  if (score >= 60) return { label: "Caution", bar: "bg-[#d97706]", tone: "yellow" };
  return { label: "High Risk", bar: "bg-[#dc2626]", tone: "red" };
}

// Pale tint for pillar tiles — recognizable at a glance, text stays dark (WCAG AA).
export const TILE_TINT = {
  green: "bg-[#f0fdf4] border-[#bbf7d0]",
  yellow: "bg-[#fffbeb] border-[#fde68a]",
  red: "bg-[#fef2f2] border-[#fecaca]",
  grey: "bg-white border-[#e5e7eb]",
};
